<!-- Contact Component -->
<script>
  import { Col, Row, Container, FormGroup, Input } from "sveltestrap"; 
  import { t, locale, locales } from "../Services/i18n";
  $: yearsOfExperience = Math.abs(new Date().getFullYear() - 2005)
</script>


<!-- CONTACT FORM START-->
<section class="section common-section" id="contact">

  <Container>
    <Row>
      <Col lg={{ size: 8, offset: 2 }}>
        <h1 class="section-title text-center">{$t("contactus.title")}</h1>
        <div class="section-title-border mt-3" />
        <p class="section-subtitle text-muted text-center font-secondary pt-4">
            {$t("contactus.subtitle", {yearsOfExperience})}
        </p>    
      </Col>
    </Row>
    <Row>
      <Col lg="12">
        <div class="custom-form mt-4 pt-4">
          <section class="contact-social bg-light">
            <Container>
              <Row class="align-items-center">               
                <Col lg="4" class="mt-5">
                  <p class="contact-title">
                    <i class="pe-7s-call" />
                  </p>
                  <p class="contact-title">
                     <a href="tel:551-278-8200" target="_system">(973)343-7777</a>
                  </p>
                </Col>
                <Col lg="4" class="mt-5">
                  <p class="contact-title">
                    <i class="pe-7s-map-marker" />
                  </p>                  
                  <p class="contact-title">
                    <a href="https://goo.gl/maps/ECoSo1mcTddw58f46" target="_blank" rel="noreferrer">33 E. Blackwell St.<br>Dover, NJ 07801</a>
                  </p>         
                </Col>                 
                <Col lg="4" class="mt-5">
                  <p class="contact-title">
                    <i class="pe-7s-mail-open" />
                  </p>                  
                  <p class="contact-title">
                    <a href="mailto:maite@mmatoslaw.com.com">maite@mmatoslaw.com</a><br>
                    <a href="mailto:iman@mmatoslaw.com.com">iman@mmatoslaw.com</a>
                  </p>         
                </Col>               
              </Row>
            </Container>
        </div>
      </Col>
    </Row>
  </Container>
</section>
<!-- CONTACT FORM END-->
